import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";

import { JSX, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import SessionInfo from "@/components/auth/SessionInfo.tsx";
import { IconWarningMark } from "@/components/icons";

import { useSuspenseSessions } from "@/hooks/api/login.hooks.ts";

const AuthSessions = ({ token }: { token: string }): JSX.Element => {
  const { t } = useTranslation();
  const { data } = useSuspenseSessions(token);

  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  return (
    <Dialog open={isOpen} onClose={() => {}} transition className={"headless-dialog"}>
      <DialogPanel
        transition
        className={"headless-dialog-panel max-w-[38.25rem]  rounded-[1.875rem] p-10 max-md:px-4 max-md:py-6"}
      >
        <div className={"flex flex-col items-center justify-center gap-5 max-md:gap-4"}>
          <IconWarningMark className={"size-[3.125rem]"} />
          <div className={"flex flex-col items-center gap-[0.938rem] text-center max-md:gap-2"}>
            <DialogTitle as={"h2"} className={"text-2xl font-semibold leading-6"}>
              {t("Sessions.above-limit")}
            </DialogTitle>
            <p className={"w-[80%] text-lg max-md:text-base"}>{t("Sessions.about-limit-message")}</p>
          </div>
        </div>
        <ul className={"mt-10 flex max-h-[400px] flex-col space-y-5 overflow-auto  max-lg:mt-6 max-md:space-y-2"}>
          {data.map((session) => {
            return (
              <li key={session.my_key}>
                <SessionInfo {...session} token={token} isDisabled={isDisabled} setIsDisabled={setIsDisabled} />
              </li>
            );
          })}
        </ul>
      </DialogPanel>
    </Dialog>
  );
};

export default AuthSessions;
